// extracted by mini-css-extract-plugin
export default {"PercentGauge":"PercentGauge__QezQl7kX6niE","previousPeriod":"previousPeriod__iPUP81QFxZvM","Info":"Info__X9FBieLxjNJ9"};